<template>
  <div class="public-content platform-sku">
    <div class="breadcrumb">模板组归属平台</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="searchStoreVo" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="5">
            <el-form-item label="平台号:">
              <el-input v-model="searchStoreVo.code" placeholder="" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="平台名称:">
              <el-input v-model="searchStoreVo.name" placeholder="" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="平台类型:">
              <el-select v-model="searchStoreVo.storeType" clearable placeholder="">
                <el-option v-for="item in storeTypeList" :key="item.id" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="创建日期:">
              <el-date-picker clearable v-model="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="storeList" border style="width: 100%">
          <el-table-column prop="code" label="平台号"></el-table-column>
          <el-table-column prop="name" label="平台名称"></el-table-column>
          <el-table-column prop="storeTypeName" label="平台类型"></el-table-column>
          <el-table-column prop="createdTime" label="创建日期"></el-table-column>
        </el-table>
        <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
      </div>
    </div>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index.vue'
import { storeTypeGetStoreTypeList } from '@/api/crm'
import { groupGetStoreListByGroupId } from '@/api/pms'
export default {
  name: 'platform-sku',
  components: {
    VPagination
  },
  data () {
    return {
      date: [],
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 5
      },
      searchStoreVo: {
        code: '',
        createTimeBegin: '',
        createTimeEnd: '',
        groupId: +this.$route.query.id,
        name: '',
        page: 1,
        salename: '',
        storeTypeid: ''
      },
      storeTypeList: [],
      storeList: []
    }
  },
  watch: {
    date (val) {
      this.searchStoreVo.createTimeBegin = val === null ? '' : val[0]
      this.searchStoreVo.createTimeEnd = val === null ? '' : val[1]
    }
  },
  created () {
    this.getStoreTypeList()
    this.onSubmit()
  },
  methods: {
    // 平台类型
    getStoreTypeList () {
      storeTypeGetStoreTypeList().then(res => {
        if (res.data.success) {
          this.storeTypeList = res.data.data
        }
      })
    },
    onSubmit () {
      groupGetStoreListByGroupId({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchStoreVo: this.searchStoreVo }).then(res => {
        if (res.data.success) {
          let list = res.data.data.records
          this.storeTypeList.forEach(type => {
            list.forEach(store => {
              if (store.storeType === type.code) {
                store.storeTypeName = type.name
              }
            })
          })
          this.queryInfo.total = res.data.data.total
          this.storeList = list
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
 <style scoped lang="less">
 @import "index";
 @deep: ~">>>";
 </style>
